import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ViewProjectModal = ({ show, handleClose, project }) => {
    if (!project) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View Project Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="mb-3">
                    <strong>Project ID:</strong> {project.id}
                </div>
                <div className="mb-3">
                    <strong>Name:</strong> {project.name}
                </div>
                <div className="mb-3">
                    <strong>Developer:</strong> {project.developer && project.developer.name}
                </div>
                <div className="mb-3">
                    <strong>Developer Sales:</strong> {project.developer_sales && project.developer_sales.name}
                </div>
                <div className="mb-3">
                    <strong>Project Commission:</strong> {project.projectCommission}
                </div>
                <div className="mb-3">
                <strong>Starting Price:</strong> {Number(project.startingPrice).toLocaleString()} EGP
                </div>
                <div className="mb-3">
                    <strong>Location:</strong> {project.location && project.location.name}
                </div>
      
                <div className="mb-3">
                    <strong>Payment Plans:</strong>
                    {project.payment_plans && project.payment_plans.length > 0 ? (
                        project.payment_plans.map((pp, index) => (
                            <div key={index} className="ms-3 mt-2">
                                <div className="mb-2">
                                    <strong>Plan {index + 1}:</strong>
                                    {pp.paymentplan && (
                                        <>
                                            <br />
                                            <span className="ms-3">
                                                <strong>Name: </strong> {pp.paymentplan.name} <br />
                                                <strong>Installments: </strong> {pp.paymentplan.installments} Years <br />
                                                <strong>Downpayment: </strong> {pp.paymentplan.downpayment} <strong>%</strong>
                                            </span>
                                        </>
                                    )}
                                </div>
                                {pp.offer_paymentplan && (
                                    <div className="ms-3 mb-2">
                                        <strong>Offer Plan:</strong>
                                        <br />
                                        <span className="ms-3">
                                            <strong>Name: </strong> {pp.offer_paymentplan.name} <br />
                                            <strong>Installments: </strong> {pp.offer_paymentplan.installments} Years <br />
                                            <strong>Downpayment: </strong> {pp.offer_paymentplan.downpayment} <strong>%</strong>
                                        </span>
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <span className="text-muted ms-2">No payment plans assigned</span>
                    )}
                </div>
                {project.incentive && (
                    <div className="mb-3">
                        <strong>Incentive:</strong> {project.incentive} , From : {project.incentiveStartDate} , To : {project.incentiveEndDate}
                    </div>
                )}
                <div className="mb-3">
                    <strong>Delivery Date:</strong> {project.deliveryDate && project.deliveryDate.split('-')[0]}
                </div>
                <div className="mb-3">
                    {/* This ternary already handles 0 correctly, but Boolean() adds robustness */}
                    <strong>Launch:</strong> {Boolean(project.isLaunch) ? 'Yes' : 'No'}
                </div>

                {/* Use Boolean() here to prevent rendering '0' */}
                {Boolean(project.isLaunch) && (
                    <>
                        <div className="mb-3">
                            <strong>Bank Account Name:</strong> {project.nameOfAccount || 'N/A'} {/* Added fallback */}
                        </div>
                        <div className="mb-3">
                            <strong>Bank Name:</strong> {project.bankName || 'N/A'} {/* Added fallback */}
                        </div>
                        <div className="mb-3">
                            <strong>IBAN:</strong> {project.iban || 'N/A'} {/* Added fallback */}
                        </div>
                    </>
                )}
                <div className="mb-3">
                    <strong>Sponsored:</strong> {project.isSponsored ? 'Yes' : 'No'}
                </div>
                <div className="mb-3">
                    <strong>Status:</strong> {project.status === 'approved'
                        ? 'Approved'
                        : project.status === 'rejected'
                            ? 'Rejected'
                            : 'Pending'}
                </div>
                <div className="mb-3">
                <strong>Project's Cover Photo: </strong> 
                <a
                                            href={project.picture}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#487fff', textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            View Document
                                        </a>

                </div>
                <div className="mb-3">
                <strong>Masterplan: </strong> 
                <a
                                            href={project.masterplan}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#487fff', textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            View Document
                                        </a>

                </div>
                {project.gallery && project.gallery.length > 0 && (
                    <div className="mb-3">
                        <strong>Gallery:</strong>
                        <div className="d-flex flex-wrap mt-2">
                            {project.gallery.map((image, index) => (
                                <a key={index} href={image} target="_blank" rel="noopener noreferrer" className="me-2">
                                    <img src={image} alt={`Gallery ${index + 1}`} className="rounded" style={{ width: '100px', height: 'auto' }} />
                                </a>
                            ))}
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewProjectModal;